import { PRODUCT_TYPES } from "../types";

const default_state = {
  loading: false,
  error: false,
  products: localStorage.getItem("products")
    ? JSON.parse(localStorage.getItem("products"))
    : [],
  product: {},
  categories: [],
};

const reducer = (state = default_state, action) => {
  switch (action.type) {
    case PRODUCT_TYPES.GET_PRODUCTS:
    case PRODUCT_TYPES.GET_CATEGORIES:
      return {
        ...state,
        loading: action.payload,
        error: false,
      };
    case PRODUCT_TYPES.SHOW_PRODUCTS:
      localStorage.setItem("products", JSON.stringify(action.payload));
      return {
        ...state,
        products: action.payload,
      };
    case PRODUCT_TYPES.SHOW_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case PRODUCT_TYPES.SHOW_MORE_PRODUCTS:
      return {
        ...state,
        products: state.products.concat(action.payload),
      };
    case PRODUCT_TYPES.SHOW_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      };
    case PRODUCT_TYPES.GET_SUCCESS:
      return {
        ...state,
        error: false,
        loading: action.payload,
      };
    case PRODUCT_TYPES.GET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
